import { Redirect } from 'expo-router';

import { routes } from '@fhs-legacy/frontend/src/utils/routing';

// Redirects from /v2/menu/ -> /menu/
// We should be able to remove this when we don't need to support /v2/ urls anymore
export default function MenuItemV2() {
  return <Redirect href={routes.menu} />;
}
